<template>
    <el-drawer v-model="drawer" :with-header="false" :destroy-on-close="true" class="team-edit-drawer" @close="close">
        <Loading v-if="loading || small_loading" />
        <div class="teams-set-wrap" v-else>
            <div class="teams-head">
                <i class="close" @click="close">
                    <svg-icon name="close" />
                </i>
                <h2>{{ drawerTitle }}</h2>
                <el-button
                    type="primary"
                    @click="Add()" 
                >Add</el-button>
            </div>

            <Scrollbar :class="['data-list']" :show_bar="true">
                <Table :style="'--top: 0px'" v-if="type === 1" :class="{ 'is-loading': loading}">
                    <template #head>
                        <tr>
                            <th><span>Role ({{ tableData.filter(e=> !e.is_motom_internal_role ).length }}/{{ maxlength }})</span></th>
                            <th><span>Members</span></th>
                            <th><span>Actions</span></th>
                        </tr>
                    </template>

                    <template #body>

                        <tr v-for="(row, index) in tableData" :key="index">
                            <td>
                                <div class="role-box">
                                    <span v-if="!row.Edit">{{ row.name }}</span>

                                    <div class="input-row" v-if="row.Edit">
                                        <el-input v-model="row.name" @input="validate(row)"/>
                                        <div class="err-text" v-if="row.err">{{ row.err }}</div>
                                    </div>

                                    <span class="default" v-if="row.is_default_role">Default</span>
                                    <span class="default" v-if="row.is_motom_internal_role">Internal</span>
                                    <svg-icon v-if="row.is_motom_internal_role" name="logo-m" />
                                    <span v-else-if="!row.Edit && !row.is_default_role"
                                        @click="row.Edit = true; row.tempRole = row.name;"><svg-icon
                                            name="pen" /></span>
                                    <span v-if="row.Edit" :class="['yes-icon', (!row.name || row.err) && 'yes-icon-disabeld']"
                                        @click="saveRole(row)"><svg-icon name="yes-2" /></span>
                                    <span v-if="row.Edit" class="close-icon"
                                        @click="row.Edit = false; row.name = row.tempRole;"><svg-icon
                                            name="close" /></span>
                                </div>
                            </td>

                            <td><span>{{ row.member_count }}</span></td>

                            <td>
                                <div class="actions-box">
                                    <span class="link" v-if="permission_team.editRolePermissions.permission && (!(isAdmin && row.isOwner))" @click="goEdit(row)">{{ row.isOwner || (isAdmin && row.role_name ==="Admin") ? 'View permissions' : 'Edit permissions'}}</span>
                                    <span class="link-del" v-if="!row.is_default_role && permission_team.editRolePermissions.permission" @click="delRole(row)">Delete</span>
                                    <svg-icon v-if="!permission_team.editRolePermissions.permission || (isAdmin && row.isOwner)" name="not-allow" />
                                </div>
                            </td>

                        </tr>
                    </template>

                </Table>

                <Table :style="'--top: 0px'" v-else :class="{ 'is-loading': loading}">
                    <template #head>
                        <tr>
                            <th><span>Company/Team</span></th>
                            <th><span>Members</span></th>
                            <th><span>Actions</span></th>
                        </tr>
                    </template>

                    <template #body>

                        <tr v-for="(row, index) in tableData" :key="index">
                            <td>
                                <div class="role-box">
                                    <span v-if="!row.Edit">{{ row.name }}</span>

                                    <div class="input-row" v-if="row.Edit">
                                        <el-input v-model="row.name" @input="validate(row)" />
                                        <div class="err-text" v-if="row.err">{{ row.err }}</div>
                                    </div>

                                    <span class="default" v-if="row.is_default_company">Default</span>
                                    <span class="default" v-if="row.is_motom_internal_company">Internal</span>
                                    <svg-icon v-if="row.is_motom_internal_company" name="logo-m" />
                                    <span v-else-if="!row.Edit && !row.is_default_company && !row.is_motom_internal_company"
                                        @click="row.Edit = true; row.tempName = row.name; row.err = false;"><svg-icon
                                            name="pen" /></span>
                                    <span v-if="row.Edit" :class="['yes-icon', (!row.name || row.err) && 'yes-icon-disabeld']"
                                        @click="saveRole(row)"><svg-icon name="yes-2" /></span>
                                    <span v-if="row.Edit" class="close-icon"
                                        @click="row.Edit = false; row.name = row.tempName;"><svg-icon
                                            name="close" /></span>
                                </div>
                            </td>

                            <td><span>{{ row.member_count }}</span></td>

                            <td>
                                <div class="actions-box">
                                    <svg-icon v-if="row.is_motom_internal_company" name="not-allow" />
                                    <span class="link-del" v-else @click="delTeam(row)">Delete</span>
                                </div>
                            </td>

                        </tr>
                    </template>

                </Table>
            </Scrollbar>
        </div>
    </el-drawer>

    <!-- add dialog -->
    <el-dialog :title="`Create a New Role`" width="400" v-model="addRoleDialog" @close="addRoleDialog = false"
        class="team-add-dialog">
        <div class="input-item">
            <label for="title">Role title</label>
            <el-input :class="[titleAlertVal && 'err-input']" maxlength="32" type="text" :placeholder="titlePlaceholder"
                v-model="addRoleValue.title" @input="validate({name:addRoleValue.title,spec:true})"/>
            <div class="err-text" v-if="titleAlertVal">{{ titleAlertText }}</div>
            <div class="err-text" v-if="otherAlertText">{{ otherAlertText }}</div>
        </div>
        <div class="input-item">
            <label for="title">Pick a similar role to get started</label>
            <el-select v-model="addRoleValue.similarRole" :reserve-keyword="false" placeholder="Select">
                <el-option v-for="item in roleOrgList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
        </div>
        <div class="btn-row">
            <el-button type="primary" @click="createAddRole()"
                :disabled="!addRoleValue.title || !addRoleValue.similarRole">Create</el-button>
        </div>
    </el-dialog>

    <!-- add team dialog -->
    <el-dialog :title="`Create a New Company/Team`" width="400" v-model="addTeamDialog" @close="addTeamDialog = false"
        class="team-add-dialog">
        <div class="input-item">
            <label for="title">Company/Team name</label>
            <el-input :class="[titleTeamAlertVal && 'err-input']" maxlength="64" type="text"
                :placeholder="titleTeamPlaceholder" v-model="addTeamValue.title" @input="validate({name:addTeamValue.title,spec:true})"/>
            <div class="err-text" v-if="titleTeamAlertVal">{{ titleTeamAlertText }}</div>
            <div class="err-text" v-if="otherTeamAlertText">{{ otherTeamAlertText }}</div>
        </div>
        <div class="input-item">
            <label for="title">Member (optional)</label>
            <el-select v-model="addTeamValue.similarRole" multiple filterable :reserve-keyword="false"
                placeholder="Select">
                <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
        </div>
        <div class="btn-row">
            <el-button type="primary" @click="createAddTeam()"
                :disabled="!addTeamValue.title || !addTeamValue.similarRole">Create</el-button>
        </div>
    </el-dialog>
    <!-- del -->
    <el-dialog :key="delDialogValue" :title="delDialogValue.title" width="400" v-model="delDialogValue.open" @close="delDialogValue.open = false"
        class="handle-dialog">
        <p>{{ delDialogValue.content }}</p>
        <el-select v-model="delDialogValue.pickOpt" default-first-option :reserve-keyword="false">
            <el-option v-for="item in delDialogValue.option" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
        <div class="btn-row">
            <el-button @click="delDialogValue.open = false" type="text">Discard</el-button>
            <el-button type="danger" @click="handleDel()" :disabled="!delDialogValue.pickOpt">Confirm</el-button>
        </div>
    </el-dialog>

    <!-- alert -->
    <el-dialog :title="'Custom role limit reached'" width="400" v-model="alertDialogValue.open" @close="alertDialogValue.open = false"
        class="handle-dialog">
        <p>You’ve reached the maximum number of custom roles allowed. To make changes, edit or delete existing roles.</p>
        <div class="btn-row">
            <el-button type="primary" @click="goEmail()" >Manage role</el-button>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import Scrollbar from '@/components/ui/Scrollbar.vue'
import { ElButton, ElDrawer, ElInput, ElDialog, ElSelect, ElOption } from 'element-plus'
import TableTh from '@/components/ui/TableTh.vue';
import Table from '@/components/ui/Table.vue';
import Loading from '@/components/ui/Loading.vue';
import { useRoute, useRouter } from "vue-router";
import Store from '@/store/index.js';

const emit = defineEmits(['refrash']);
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const notify = app.appContext.config.globalProperties.$notify;
const loading = ref(true);
const small_loading= ref(false);
const routerGo = useRouter();
const route = useRoute();
const drawer = ref(false);
const type = ref(1);
const tableData = ref([]);
const addRoleDialog = ref(false);
const addRoleValue = ref({
    title: '',
    similarRole: '',
});
const titlePlaceholder = ref('For example: "Marketing" or "Guest"');
const roleOrgList = ref([]);

const titleAlertText = ref('Please provide a different role name.');
const otherAlertText= ref('');
const titleAlertVal = ref(false);
//-----------------------------------
const addTeamDialog = ref(false);
const addTeamValue = ref({
    title: '',
    similarRole: [],
});
const titleTeamPlaceholder = ref('For example: "Agency" or "Design"');
const titleTeamAlertText = ref('Please provide a different company/team name.');
const otherTeamAlertText= ref('');
const titleTeamAlertVal = ref(false);
const userList = ref([]);
const delDialogValue = ref({
    open: false,
    title: '',
    content: '',
    option:[],
    pickOpt:null,
    delRow:null,
});
const alertDialogValue=ref({
    open: false,
    title: '',
    content: '',
})
//-------------------------------------------
const drawerTitle = computed(() => {
    return type.value === 1 ? 'Manage Roles' : 'Manage Company/Team';
});

const maxlength = computed(() => {
    return type.value === 1 ? 10 : 20;
});

const permission_team = computed(() => {
  return Store.state.user_data?.permission_list?.settingWorkspace;
});
const isOwner=computed(()=> {
    let val = Store.state.user_data.permission_list;
    return val?.role_type === 100 || val?.role_type === 200;
});
const isAdmin=computed(()=> {
    let val = Store.state.user_data.permission_list;
    return val?.role_type === 80;
});
//++++++++++++++++++++++++++++++++++++++++++++++
const open = async (item) => {
    loading.value = true;
    tableData.value=[];
    type.value = item.id;
    drawer.value = true;
    if (type.value === 1) {
        getPermissionRole();
        getRoleOrgList();
    } else {
        getCompanyList();
        getCompanyUserList();
    }
}

const close = () => {
    drawer.value = false;
    emit('refrash');
};

const validate = (row) => {

    if (row.name.includes(' ')) {
        row.err = 'Tip: You can use underscores (_) or hyphens (-) instead of spaces';
    }
    else if (!/^[\w-]+$/.test(row.name)) {
        row.err = 'Only letters, numbers, underscores (_) and hyphens (-) are allowed';

    }
    else if ((type.value === 1 && row.name.length > 32 )|| (type.value === 2 && row.name.length > 64 )) {
        row.err = 'Character limit reached';
    } else if (tableData.value.some(item => item !== row && item.name === row.name)) {
        row.err = type.value ===1 ? titleAlertText .value:titleTeamAlertText.value;
    } else {
        row.err = '';
    }

    if(row.spec){
        if(type.value === 1 ){
            otherAlertText.value= row.err;
        }else{
            otherTeamAlertText.value= row.err;
        }
    }
};

//update name
const saveRole = (row) => {
    if (!row.name || row.err) {
        return;
    } else {
        //row.err=true;
        loading.value = true;
        if(type.value === 1){
            let formData = new FormData();
            formData.append('role_id', row.id);
            formData.append('role_name', row.name);
            ajax.post(`/settings/update-role-info`, formData, {
                headers: {
                'Content-Type': 'multipart/form-data',
                },
            }).then(res => {
                notify({
                    text: `<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.99992 0.333313C3.31992 0.333313 0.333252 3.31998 0.333252 6.99998C0.333252 10.68 3.31992 13.6666 6.99992 13.6666C10.6799 13.6666 13.6666 10.68 13.6666 6.99998C13.6666 3.31998 10.6799 0.333313 6.99992 0.333313ZM5.66659 10.3333L2.33325 6.99998L3.27325 6.05998L5.66659 8.44665L10.7266 3.38665L11.6666 4.33331L5.66659 10.3333Z" />
                    </svg> ${row.name} updated successfully.`,
                    group: 'white',
                    type: 'success',
                });
                loading.value = false;
                row.Edit = false;
            }).catch(err=>{
                row.err= err.response.data.message || 'Update failed';
                loading.value = false;
            })
        }else{
            let formData = new FormData();
            formData.append('company_id', row.id);
            formData.append('company_name', row.name);
            ajax.post(`/settings/update-company-info`, formData, {
                headers: {
                'Content-Type': 'multipart/form-data',
                },
            }).then(res => {
                notify({
                    text: `<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.99992 0.333313C3.31992 0.333313 0.333252 3.31998 0.333252 6.99998C0.333252 10.68 3.31992 13.6666 6.99992 13.6666C10.6799 13.6666 13.6666 10.68 13.6666 6.99998C13.6666 3.31998 10.6799 0.333313 6.99992 0.333313ZM5.66659 10.3333L2.33325 6.99998L3.27325 6.05998L5.66659 8.44665L10.7266 3.38665L11.6666 4.33331L5.66659 10.3333Z" />
                    </svg> ${row.name} updated successfully.`,
                    group: 'white',
                    type: 'success',
                });
                loading.value = false;
                row.Edit = false;
            }).catch(err=>{
                row.err= err.response.data.message || 'Update failed';
                loading.value = false;
            })
        }
       
    }
}

const goEmail = () => {
    alertDialogValue.value.open = false;
};

//open add
const Add = () => {

    if(tableData.value.filter(e=> !e.is_motom_internal_role ).length >= maxlength.value && type.value === 1){
        if(type.value === 1){
            alertDialogValue.value.open = true;
        }
        return;
    }

    if (type.value === 1) {
        titleAlertVal.value = false;
        addRoleDialog.value = true;
        addRoleValue.value = {
            title: '',
            similarRole: '',
        };
    } else {
        titleTeamAlertVal.value = false;
        addTeamValue.value = {
            title: '',
            similarRole: [],
        };
        addTeamDialog.value = true;
    }

    otherAlertText.value= '';   
    otherTeamAlertText.value= '';

};

const createAddRole = () => {
    if (!addRoleValue.value.title) {
        titleAlertVal.value = true;
        return;
    } else if(tableData.value.map(item => item.name).includes(addRoleValue.value.title)){
        titleAlertVal.value = true;
        titleAlertText.value = 'This role already exists.';
        return;
    }else{
        titleAlertVal.value = false;
    }

    let formData = new FormData();
    formData.append('role_name', addRoleValue.value.title);
    formData.append('reference_role_id', addRoleValue.value.similarRole);


    loading.value = true;
    ajax.post(`/settings/create-role`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }).then(res => {
        const newTeam = {
            company_name: addRoleValue.value.title,
            member_count: res.data.data.affected_count,
            Edit: false,
        };
        tableData.value.push(newTeam);
        notify({
            text: `<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.99992 0.333313C3.31992 0.333313 0.333252 3.31998 0.333252 6.99998C0.333252 10.68 3.31992 13.6666 6.99992 13.6666C10.6799 13.6666 13.6666 10.68 13.6666 6.99998C13.6666 3.31998 10.6799 0.333313 6.99992 0.333313ZM5.66659 10.3333L2.33325 6.99998L3.27325 6.05998L5.66659 8.44665L10.7266 3.38665L11.6666 4.33331L5.66659 10.3333Z" />
                </svg> ${addRoleValue.value.title} updated successfully.`,
            group: 'white',
            type: 'success',
        });
        addRoleValue.value.title = '';
        addRoleValue.value.similarRole = '';
        tableData.value=[];
        getPermissionRole();
        getRoleOrgList();
    }).catch(err => {
        notify({
            text: `<svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0.439453C4.48 0.439453 0 4.91945 0 10.4395C0 15.9595 4.48 20.4395 10 20.4395C15.52 20.4395 20 15.9595 20 10.4395C20 4.91945 15.52 0.439453 10 0.439453ZM11 15.4395H9V13.4395H11V15.4395ZM11 11.4395H9V5.43945H11V11.4395Z"/>
            </svg>
            ${titleAlertText.value}`,
            group: 'white',
            type: 'success',
        });
        loading.value = false;
    });
    addRoleDialog.value = false;
};

const createAddTeam = () => {
    if (!addTeamValue.value.title) {
        titleTeamAlertVal.value = true;
        return;
    } else if(tableData.value
        .map(item => item.name.toLowerCase())
        .includes(addTeamValue.value.title.toLowerCase())){
        titleTeamAlertVal.value = true;
        return;
    }else {
        titleTeamAlertVal.value = false;
    }

    let formData = new FormData();
    formData.append('company_name', addTeamValue.value.title);

    addTeamValue.value.similarRole.forEach(id => {
        formData.append('portal_user_ids[]', id);
    });

    loading.value = true;
    ajax.post(`/settings/create-company`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }).then(res => {
        const newTeam = {
            company_name: addTeamValue.value.title,
            member_count: res.data.data.affected_count,
            Edit: false,
        };
        tableData.value.push(newTeam);
        notify({
            text: `<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.99992 0.333313C3.31992 0.333313 0.333252 3.31998 0.333252 6.99998C0.333252 10.68 3.31992 13.6666 6.99992 13.6666C10.6799 13.6666 13.6666 10.68 13.6666 6.99998C13.6666 3.31998 10.6799 0.333313 6.99992 0.333313ZM5.66659 10.3333L2.33325 6.99998L3.27325 6.05998L5.66659 8.44665L10.7266 3.38665L11.6666 4.33331L5.66659 10.3333Z" />
                </svg> ${addTeamValue.value.title} updated successfully.`,
            group: 'white',
            type: 'success',
        });
        addTeamValue.value.title = '';
        addTeamValue.value.similarRole = [];
        tableData.value=[];
        getCompanyList();
        
    }).catch(err => {
        notify({
            text: `<svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0.439453C4.48 0.439453 0 4.91945 0 10.4395C0 15.9595 4.48 20.4395 10 20.4395C15.52 20.4395 20 15.9595 20 10.4395C20 4.91945 15.52 0.439453 10 0.439453ZM11 15.4395H9V13.4395H11V15.4395ZM11 11.4395H9V5.43945H11V11.4395Z"/>
            </svg>
            ${titleTeamAlertText.value}`,
            group: 'white',
            type: 'success',
        });
        loading.value = false;
    });
    
    addTeamDialog.value = false;
};

const delRole = (row) => {
    if(!row.id){
        row = tableData.value.filter(item => item.id === row)[0];
    }
    delDialogValue.value.open = false;
    delDialogValue.value.delRow = row;
    delDialogValue.value.pickOpt = '';
    delDialogValue.value.option = tableData.value.filter(item => item !== row && item.role_type !==100 && item.role_type !==200);
    delDialogValue.value.title = 'Delete this custom role?';
    delDialogValue.value.content = `You’re about to remove the "${row.name}" role from the portal. Members currently assigned to it will be moved to the following role:`;
    delDialogValue.value.type= 1;
    setTimeout(() => {
        delDialogValue.value.open = true;
    }, 100);
};

const delTeam = (row) => {
    if(!row.id){
        row = tableData.value.filter(item => item.id === row)[0];
    }
    delDialogValue.value.open = false;
    delDialogValue.value.delRow = row;
    delDialogValue.value.pickOpt = '';
    delDialogValue.value.option = tableData.value.filter(item => item !== row);
    delDialogValue.value.title = 'Delete this company/team?';
    delDialogValue.value.content = `You are about to remove the ${row.name} from the portal. Members currently in the ${row.name} will be moved to the following:`;
    delDialogValue.value.type= 2;
    setTimeout(() => {
        delDialogValue.value.open = true;
    }, 100);
};

//go other page to edit
const goEdit = (row) => {
    routerGo.push(`/settings/team-setting/${row.id}`)
};

const getPermissionRole = () => {
    loading.value = true;
    ajax.get('/settings/get-permission-role-list').then(res => {
        tableData.value=[];
        tableData.value = res.data.data.map(item => ({
            ...item,
            Edit: false,
            name: item.role_name,
            isOwner: item.role_type=== 100 || item.role_type === 200,
        }));
        console.log(tableData.value)
        loading.value = false;
    }).catch(err=>{
        loading.value = false;
    })
};

const getCompanyList = () => {
    loading.value = true;
    ajax.get('/settings/get-company-list').then(res => {
        tableData.value=[];
        tableData.value = res.data.data.map(item => ({
            ...item,
            name: item.company_name,
            Edit: false,
        }));
        loading.value = false;
    }); 
};

const getCompanyUserList=()=>{
    small_loading.value = true;
    ajax.get('/settings/get-lower-role-user-list').then(res => {
        userList.value = res.data.data;
        small_loading.value = false;
    });
};

const getRoleOrgList=()=>{
    small_loading.value = true;
    ajax.get('/settings/get-create-role-dropdown-list').then(res => {
        roleOrgList.value = res.data.data.map(item => ({
            ...item,
            name: item.role_name,
        })).sort((a, b) => b.is_default_role - a.is_default_role);
        small_loading.value = false;
    });
};

const handleDel=()=>{
    if(delDialogValue.value.type === 1){
        callDelRoleApi();
    }else{
        callDelTeamApi();
    }
};

const callDelRoleApi=()=>{
    let formData = new FormData();
    formData.append('role_id', delDialogValue.value.delRow.id);
    formData.append('target_role_id', delDialogValue.value.pickOpt);
    loading.value = true;
    ajax.post(`/settings/delete-role`, formData, {
        headers: {
        'Content-Type': 'multipart/form-data',
        },
    }).then(res => {
        notify({
        text: `<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.99992 0.333313C3.31992 0.333313 0.333252 3.31998 0.333252 6.99998C0.333252 10.68 3.31992 13.6666 6.99992 13.6666C10.6799 13.6666 13.6666 10.68 13.6666 6.99998C13.6666 3.31998 10.6799 0.333313 6.99992 0.333313ZM5.66659 10.3333L2.33325 6.99998L3.27325 6.05998L5.66659 8.44665L10.7266 3.38665L11.6666 4.33331L5.66659 10.3333Z" />
        </svg> ${delDialogValue.value.delRow.name} delete successfully.`,
        group: 'white',
        type: 'success',
        });
        loading.value = false;
        tableData.value.filter(item => item.id !== delDialogValue.value.delRow.id);
        delDialogValue.value.open = false;
        getPermissionRole();
        getRoleOrgList();
    }).catch(err => {
        notify({
        text: `<svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 0.439453C4.48 0.439453 0 4.91945 0 10.4395C0 15.9595 4.48 20.4395 10 20.4395C15.52 20.4395 20 15.9595 20 10.4395C20 4.91945 15.52 0.439453 10 0.439453ZM11 15.4395H9V13.4395H11V15.4395ZM11 11.4395H9V5.43945H11V11.4395Z"/>
        </svg>
        ${delDialogValue.value.delRow.name} delete failed.`,
        group: 'white',
        type: 'warn',
        });
        loading.value = false;
    })
};

const callDelTeamApi=()=>{
    let formData = new FormData();
    formData.append('company_id', delDialogValue.value.delRow.id);
    formData.append('target_company_id', delDialogValue.value.pickOpt);
    loading.value = true;
    ajax.post(`/settings/delete-company`, formData, {
        headers: {
        'Content-Type': 'multipart/form-data',
        },
    }).then(res => {
        notify({
        text: `<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.99992 0.333313C3.31992 0.333313 0.333252 3.31998 0.333252 6.99998C0.333252 10.68 3.31992 13.6666 6.99992 13.6666C10.6799 13.6666 13.6666 10.68 13.6666 6.99998C13.6666 3.31998 10.6799 0.333313 6.99992 0.333313ZM5.66659 10.3333L2.33325 6.99998L3.27325 6.05998L5.66659 8.44665L10.7266 3.38665L11.6666 4.33331L5.66659 10.3333Z" />
        </svg> ${delDialogValue.value.delRow.name} delete successfully.`,
        group: 'white',
        type: 'success',
        });
        loading.value = false;
        tableData.value.filter(item => item.id !== delDialogValue.value.delRow.id);
        delDialogValue.value.open = false;
        getCompanyList();
    }).catch(err => {
        notify({
        text: `<svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 0.439453C4.48 0.439453 0 4.91945 0 10.4395C0 15.9595 4.48 20.4395 10 20.4395C15.52 20.4395 20 15.9595 20 10.4395C20 4.91945 15.52 0.439453 10 0.439453ZM11 15.4395H9V13.4395H11V15.4395ZM11 11.4395H9V5.43945H11V11.4395Z"/>
        </svg>
        ${delDialogValue.value.delRow.name} delete failed.`,
        group: 'white',
        type: 'warn',
        });
        loading.value = false;
    })
}

onMounted(async () => {

});

defineExpose({
    open,
    close,
})
</script>

<script>
export default {
    name: 'Team'
}
</script>

<style lang="scss">
.team-edit-drawer {
    width: calc(100% - 300px) !important;
    max-width: 800px;
    .el-button{
        &.is-disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }

    .teams-set-wrap {
        padding: 24px;

        .teams-head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
            gap: 16px;

            h2 {
                font: var(--medium-24);
                text-align: left;
                flex: 1;
            }

            .close {
                cursor: pointer;

                svg {
                    width: 18px;
                    height: 18px;
                    rotate: -180deg;
                }
            }
        }

        .tbody,
        .thead {

            svg {
                width: 14px;
                height: 14px;
                fill: var(--black-50);
                cursor: pointer;

                &.svg-icon--logo-m,
                &.svg-icon--not-allow {
                    cursor: default;
                }
            }

            .yes-icon svg {
                fill: var(--green);
            }

            .yes-icon-disabeld svg {
                fill: var(--black-50);
                cursor: not-allowed;
            }

            .close-icon svg {
                fill: var(--red);
                width: 12px;
                height: 12px;
            }

            .input-row {
                .err-text {
                    color: var(--red);
                    margin-top: 4px;
                }
            }

            span {
                font: var(--medium-14);

                &.default {
                    color: var(--black-50);
                }

                &.link {
                    color: var(--blue);
                    cursor: pointer;

                    &:hover {
                        color: #0c72de;
                    }
                }

                &.link-del {
                    color: var(--red);
                    cursor: pointer;

                    &:hover {
                        color: var(--dark-red);
                    }
                }
            }

            .role-box,
            .actions-box {
                display: flex;
                align-items: center;
                gap: 16px;
            }
        }
    }
}

.team-add-dialog {
    .input-item {
        margin-bottom: 16px;

        label {
            font: var(--medium-14);
            color: var(--black-90);
            margin-bottom: 8px;
            display: block;
        }

        .el-input {
            width: 100%;
        }
    }

    .btn-row {
        text-align: right;

        .el-button {
            padding: 8px 16px;
        }
    }

    .err-input {
        border: 1px solid var(--red);
        border-radius: 8px;
    }

    .err-text {
        color: var(--red);
        margin-top: 4px;
        text-align: right;
    }
}
</style>